<aside class="lateral" aria-label="Estado da implantação">

  <section class="lateral__bloco">
    <h6 class="lateral__titulo">Onde estamos</h6>
    <strong class="lateral__etapa">{{ conversa.ondeEstamos.rotulo }}</strong>
    <small class="lateral__detalhe" *ngIf="conversa.ondeEstamos.detalhe">{{ conversa.ondeEstamos.detalhe }}</small>
    <code class="lateral__codigo">{{ conversa.etapa }}</code>
    <small class="lateral__aviso" *ngIf="conversa.acaoPendente">
      Aprovação aguardando o lojista
    </small>
  </section>

  <section class="lateral__bloco">
    <h6 class="lateral__titulo">
      Entregas <span class="lateral__contador">{{ conversa.entregasConcluidas }}/4</span>
    </h6>
    <ul class="lateral__entregas">
      <li *ngFor="let entrega of conversa.entregas"
          [ngClass]="classeDaEntrega(entrega)"
          [class.lateral__entrega--atual]="entrega.atual">
        <span class="lateral__marca" aria-hidden="true"></span>
        <span class="lateral__entrega-texto">
          <strong>{{ entrega.rotulo }}</strong>
          <small>{{ entrega.estadoLegivel }}</small>
        </span>
      </li>
    </ul>
  </section>

  <section class="lateral__bloco">
    <h6 class="lateral__titulo">Quem responde</h6>
    <ng-container *ngIf="conversa.modeloAtual; else semModelo">
      <code class="lateral__modelo">{{ conversa.modeloAtual }}</code>
      <small class="lateral__detalhe">via {{ provedor }}</small>
    </ng-container>
    <ng-template #semModelo>
      <small class="lateral__detalhe">Aparece quando a Mia responder o primeiro turno.</small>
    </ng-template>

    <dl class="lateral__turno" *ngIf="conversa.ultimaTelemetria as telemetria">
      <div>
        <dt>Último turno</dt>
        <dd>{{ duracao(telemetria.latenciaMs) }}</dd>
      </div>
      <div>
        <dt>Tokens</dt>
        <dd>{{ telemetria.tokensEntrada || 0 }} → {{ telemetria.tokensSaida || 0 }}</dd>
      </div>
      <div>
        <dt>Custo</dt>
        <dd>{{ custo(telemetria.custoUsd) }}</dd>
      </div>
    </dl>
  </section>

</aside>
